'use client'

import { OTPInput, OTPInputContext } from 'input-otp'
import * as React from 'react'
import { cn } from '@/src/utils/styles'

function InputOTP({
  className,
  containerClassName,
  ...props
}: React.ComponentProps<typeof OTPInput> & {
  containerClassName?: string
}) {
  return (
    <OTPInput
      data-slot='input-otp'
      containerClassName={cn(
        'flex w-96 h-11 items-center justify-between rounded-[16px] border-2 border-input-border has-[:focus]:border-input-border-focus bg-background px-0 overflow-hidden',
        containerClassName,
      )}
      className={cn('disabled:cursor-not-allowed', className)}
      {...props}
    />
  )
}

function InputOTPGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='input-otp-group'
      className={cn(
        'flex flex-1 flex-row justify-between items-center h-full',
        className,
      )}
      {...props}
    />
  )
}

function InputOTPSlot({
  index,
  className,
  ...props
}: React.ComponentProps<'div'> & {
  index: number
}) {
  const inputOTPContext = React.useContext(OTPInputContext)
  const { char, hasFakeCaret, isActive } = inputOTPContext?.slots[index] ?? {}

  return (
    <div
      data-slot='input-otp-slot'
      data-active={isActive}
      className={cn(
        'relative flex flex-col items-center justify-end h-full w-1/6',
        index !== 0 && 'outline outline-1 outline-border1',
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          'flex items-center justify-center h-full',
          'text-xl font-mono',
          'bg-transparent',
          'transition-all',
          isActive ? 'text-orange-400' : 'text-primary',
        )}
        style={{ minHeight: '2.5rem' }}
      >
        {char}
        {hasFakeCaret && (
          <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
            <div
              className={cn(
                'animate-caret-blink h-4 w-px duration-1000',
                isActive ? 'bg-primary' : 'bg-white',
              )}
            />
          </div>
        )}
      </div>
    </div>
  )
}

// function InputOTPSeparator({ ...props }: React.ComponentProps<'div'>) {
//   return (
//     <div data-slot='input-otp-separator' {...props}>
//       <MinusIcon />
//     </div>
//   )
// }

function OTP(
  props: Omit<
    React.ComponentProps<typeof InputOTP>,
    'maxLength' | 'children' | 'render'
  > & { groupClassName?: string; slotClassName?: string },
) {
  return (
    <InputOTP maxLength={6} {...props}>
      <InputOTPGroup className={props.groupClassName}>
        {Array.from({ length: 6 }).map((_, index) => (
          <InputOTPSlot
            key={index}
            index={index}
            className={props.slotClassName}
          />
        ))}
      </InputOTPGroup>
    </InputOTP>
  )
}

export { OTP }
